var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.nodeConfig.type != 4
        ? _c(
            "div",
            { staticClass: "node-wrap" },
            [
              _c(
                "div",
                {
                  staticClass: "node-wrap-box",
                  class:
                    (_vm.nodeConfig.type == 0 ? "start-node " : "") +
                    (_vm.isTried && _vm.nodeConfig.error ? "active error" : ""),
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        style:
                          "background: rgb(" +
                          ["87, 106, 149", "255, 148, 62", "50, 150, 250"][
                            _vm.nodeConfig.type
                          ] +
                          ");",
                      },
                      [
                        _c("span", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.nodeConfig.type == 1,
                              expression: "nodeConfig.type == 1",
                            },
                          ],
                          staticClass: "iconfont iconshenpi mr10",
                        }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.nodeConfig.type == 2,
                              expression: "nodeConfig.type == 2",
                            },
                          ],
                          staticClass: "iconfont iconchaosong mr10",
                        }),
                        _vm._v(" "),
                        _vm.nodeConfig.type == 0
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.nodeConfig.nodeName)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.nodeConfig.type != 0 && _vm.isInput
                          ? _c("input", {
                              directives: [
                                { name: "focus", rawName: "v-focus" },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.nodeConfig.nodeName,
                                  expression: "nodeConfig.nodeName",
                                },
                              ],
                              staticClass: "ant-input editable-title-input",
                              attrs: {
                                type: "text",
                                placeholder:
                                  _vm.placeholderList[_vm.nodeConfig.type],
                              },
                              domProps: { value: _vm.nodeConfig.nodeName },
                              on: {
                                blur: function ($event) {
                                  return _vm.blurEvent()
                                },
                                focus: function ($event) {
                                  return $event.currentTarget.select()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.nodeConfig,
                                    "nodeName",
                                    $event.target.value
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.nodeConfig.type != 0 && !_vm.isInput
                          ? _c(
                              "span",
                              {
                                staticClass: "editable-title",
                                on: {
                                  click: function ($event) {
                                    return _vm.clickEvent()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.nodeConfig.nodeName) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.nodeConfig.type != 0
                          ? _c("i", {
                              staticClass: "anticon anticon-close close",
                              on: {
                                click: function ($event) {
                                  return _vm.delNode()
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", on: { click: _vm.setPerson } },
                      [
                        _vm.nodeConfig.type == 0
                          ? _c("div", { staticClass: "text" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$func.conditionDepartment(
                                      _vm.flowPermission
                                    )
                                      ? _vm.$func.conditionDepartment(
                                          _vm.flowPermission
                                        )
                                      : "所有人"
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.nodeConfig.type == 1
                          ? _c("div", { staticClass: "text" }, [
                              !_vm.$func.setApproverStr(_vm.nodeConfig)
                                ? _c("span", { staticClass: "placeholder" }, [
                                    _vm._v(
                                      "\n              请选择" +
                                        _vm._s(
                                          _vm.placeholderList[
                                            _vm.nodeConfig.type
                                          ]
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$func.setApproverStr(_vm.nodeConfig)
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.nodeConfig.type == 2
                          ? _c("div", { staticClass: "text" }, [
                              !_vm.$func.copyerStr(_vm.nodeConfig)
                                ? _c("span", { staticClass: "placeholder" }, [
                                    _vm._v(
                                      "\n              请选择" +
                                        _vm._s(
                                          _vm.placeholderList[
                                            _vm.nodeConfig.type
                                          ]
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$func.copyerStr(_vm.nodeConfig)) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i", { staticClass: "anticon anticon-right arrow" }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isTried && _vm.nodeConfig.error
                      ? _c("div", { staticClass: "error_tip" }, [
                          _c("i", {
                            staticClass: "anticon anticon-exclamation-circle",
                            staticStyle: { color: "rgb(242, 86, 67)" },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("addNode", {
                attrs: { childNodeP: _vm.nodeConfig.childNode },
                on: {
                  "update:childNodeP": function ($event) {
                    return _vm.$set(_vm.nodeConfig, "childNode", $event)
                  },
                  "update:child-node-p": function ($event) {
                    return _vm.$set(_vm.nodeConfig, "childNode", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.nodeConfig.type == 4
        ? _c("div", { staticClass: "branch-wrap" }, [
            _c(
              "div",
              { staticClass: "branch-box-wrap" },
              [
                _c(
                  "div",
                  { staticClass: "branch-box" },
                  [
                    _c(
                      "button",
                      { staticClass: "add-branch", on: { click: _vm.addTerm } },
                      [_vm._v("添加条件")]
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.nodeConfig.conditionNodes,
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-box" },
                          [
                            _c("div", { staticClass: "condition-node" }, [
                              _c(
                                "div",
                                { staticClass: "condition-node-box" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "auto-judge condition-fields",
                                      class:
                                        _vm.isTried && item.error
                                          ? "error active"
                                          : "",
                                      style: {
                                        pointerEvents:
                                          item.isDefault === true
                                            ? "none"
                                            : "auto",
                                      },
                                    },
                                    [
                                      index != 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "sort-left",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.arrTransfer(
                                                    index,
                                                    -1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("<")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "title-wrapper" },
                                        [
                                          _vm.isInputList[index]
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "focus",
                                                    rawName: "v-focus",
                                                  },
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: item.nodeName,
                                                    expression: "item.nodeName",
                                                  },
                                                ],
                                                staticClass:
                                                  "ant-input editable-title-input",
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: item.nodeName,
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.blurEvent(index)
                                                  },
                                                  focus: function ($event) {
                                                    return $event.currentTarget.select()
                                                  },
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      item,
                                                      "nodeName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isInputList[index]
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "editable-title",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clickEvent(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.nodeName) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "priority-title",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setPerson(
                                                    item.priorityLevel
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    优先级" +
                                                  _vm._s(item.priorityLevel) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "anticon anticon-close close",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delTerm(index)
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      index !=
                                      _vm.nodeConfig.conditionNodes.length - 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "sort-right",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.arrTransfer(index)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  >\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "content",
                                          on: {
                                            click: function ($event) {
                                              return _vm.setPerson(
                                                item.priorityLevel
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$func.conditionStr(
                                                  _vm.nodeConfig,
                                                  index,
                                                  _vm.typeStr
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isTried && item.error
                                        ? _c(
                                            "div",
                                            { staticClass: "error_tip" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "anticon anticon-exclamation-circle",
                                                staticStyle: {
                                                  color: "rgb(242, 86, 67)",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: { type: "hidden" },
                                        domProps: {
                                          value: _vm.$func.conditionFieldsStr(
                                            _vm.nodeConfig,
                                            index
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("addNode", {
                                    attrs: { childNodeP: item.childNode },
                                    on: {
                                      "update:childNodeP": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "childNode",
                                          $event
                                        )
                                      },
                                      "update:child-node-p": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "childNode",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            item.childNode && item.childNode
                              ? _c("nodeWrap", {
                                  attrs: {
                                    nodeConfig: item.childNode,
                                    tableId: _vm.tableId,
                                    typeStr: _vm.typeStr,
                                    isTried: _vm.isTried,
                                  },
                                  on: {
                                    "update:nodeConfig": function ($event) {
                                      return _vm.$set(item, "childNode", $event)
                                    },
                                    "update:node-config": function ($event) {
                                      return _vm.$set(item, "childNode", $event)
                                    },
                                    "update:isTried": function ($event) {
                                      _vm.isTried = $event
                                    },
                                    "update:is-tried": function ($event) {
                                      _vm.isTried = $event
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index == 0
                              ? _c("div", {
                                  staticClass: "top-left-cover-line",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index == 0
                              ? _c("div", {
                                  staticClass: "bottom-left-cover-line",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index == _vm.nodeConfig.conditionNodes.length - 1
                              ? _c("div", {
                                  staticClass: "top-right-cover-line",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index == _vm.nodeConfig.conditionNodes.length - 1
                              ? _c("div", {
                                  staticClass: "bottom-right-cover-line",
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("addNode", {
                  attrs: { childNodeP: _vm.nodeConfig.childNode },
                  on: {
                    "update:childNodeP": function ($event) {
                      return _vm.$set(_vm.nodeConfig, "childNode", $event)
                    },
                    "update:child-node-p": function ($event) {
                      return _vm.$set(_vm.nodeConfig, "childNode", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.nodeConfig.childNode && _vm.nodeConfig.childNode
        ? _c("nodeWrap", {
            attrs: {
              nodeConfig: _vm.nodeConfig.childNode,
              tableId: _vm.tableId,
              typeStr: _vm.typeStr,
              isTried: _vm.isTried,
            },
            on: {
              "update:nodeConfig": function ($event) {
                return _vm.$set(_vm.nodeConfig, "childNode", $event)
              },
              "update:node-config": function ($event) {
                return _vm.$set(_vm.nodeConfig, "childNode", $event)
              },
              "update:isTried": function ($event) {
                _vm.isTried = $event
              },
              "update:is-tried": function ($event) {
                _vm.isTried = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }